import type { ContractBase } from '@/types/policy/PolicyTypes'

export function isEMobilContract(object: any): object is EMobilContract {
  return object && 'isEMobil' in object
}

export interface EMobilContract {
  contractBase: ContractBase
  isEMobil: boolean
  insuredVehicle: InsuredEMobil[]
}

export interface InsuredEMobil {
  sequence: number | null
  yearOfProduction: string | null
  manufacturer: string | null
  identification: string | null
  type: string | null
  insuredSum: number | null
  deductible: number | null
}
